import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

// True for routes inside an organization — the regular member tree (/org/:slug)
// and the super-admin impersonation tree (/super-admin/org/:slug). Administration
// routes (/super-admin, /super-admin/user-subscriptions, /super-admin/member-activity)
// are NOT org routes.
export const isOrgRoutePath = (path: string): boolean =>
  path.startsWith('/org/') || path.startsWith('/super-admin/org/')

export function useOrgRouteContext(): { isOnOrgRoute: ComputedRef<boolean> } {
  const route = useRoute()
  const isOnOrgRoute = computed(() => isOrgRoutePath(route.path))
  return { isOnOrgRoute }
}
